import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useSearch } from "@/context/SearchContext";
import { SeverityBadge } from "@/components/SeverityBadge";
import { Newspaper, FireSimple, ShieldWarning } from "@phosphor-icons/react";

export default function NDays() {
  const [cves, setCves] = useState([]);
  const [sevFilter, setSevFilter] = useState("");
  const { query } = useSearch();

  const load = useCallback(async () => {
    const { data } = await api.get("/cve");
    setCves(data.cves);
  }, []);
  useEffect(() => { load(); }, [load]);

  const q = query.trim().toLowerCase();
  const filtered = cves.filter((c) =>
    (!sevFilter || c.severity === sevFilter) &&
    (!q || [c.cve_id, c.title, c.product].join(" ").toLowerCase().includes(q)));
  const kev = cves.filter((c) => c.exploited).length;

  return (
    <div data-testid="ndays-page">
      <div className="mb-6">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#00F0FF]">Known Exploited Vulnerabilities</p>
        <h1 className="font-head text-3xl tracking-tighter font-black mt-1">N-Days / CVE Feed</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
        {[["Tracked CVEs", cves.length, "#00F0FF", Newspaper], ["Actively Exploited", kev, "#FF3B30", FireSimple], ["Critical", cves.filter(c => c.severity === "critical").length, "#FF9500", ShieldWarning]].map(([l, v, c, Icon]) => (
          <div key={l} className="bg-[#0C0C14] border border-[#1F1F33] p-4 flex items-center justify-between">
            <div><div className="text-[10px] uppercase tracking-[0.15em] text-[#71717A]">{l}</div><div className="font-head text-3xl font-black mt-1" style={{ color: c }}>{v}</div></div>
            <Icon size={22} weight="duotone" color={c} />
          </div>
        ))}
      </div>

      <div className="flex gap-2 mb-4">
        {["", "critical", "high", "medium"].map((s) => (
          <button key={s || "all"} data-testid={`cve-filter-${s || "all"}`} onClick={() => setSevFilter(s)}
            className={`text-[10px] uppercase tracking-wider px-3 py-1.5 border transition-colors ${sevFilter === s ? "border-[#00F0FF] text-[#00F0FF]" : "border-[#1F1F33] text-[#71717A] hover:text-white"}`}>
            {s || "all"}
          </button>
        ))}
      </div>

      <div className="space-y-2" data-testid="cve-list">
        {filtered.map((c) => (
          <div key={c.cve_id} data-testid={`cve-${c.cve_id}`} className="bg-[#0C0C14] border border-[#1F1F33] p-4 hover:border-[#33334D] transition-colors">
            <div className="flex items-center gap-3 flex-wrap">
              <span className="font-mono text-sm text-[#00F0FF]">{c.cve_id}</span>
              <SeverityBadge level={c.severity} />
              <span className="text-[10px] font-mono text-[#71717A] border border-[#1F1F33] px-1.5">CVSS {c.cvss}</span>
              {c.exploited && <span className="text-[10px] uppercase tracking-wider text-[#FF3B30] border border-[#FF3B30]/50 px-1.5 flex items-center gap-1"><FireSimple size={10} weight="fill" /> KEV</span>}
              <span className="text-[10px] text-[#71717A] ml-auto">{c.published}</span>
            </div>
            <div className="text-sm mt-2">{c.title}</div>
            <div className="text-[11px] text-[#71717A] mt-0.5">{c.product}</div>
            <p className="text-xs text-[#A1A1AA] mt-1">{c.summary}</p>
          </div>
        ))}
        {filtered.length === 0 && <div className="text-xs text-[#71717A] py-10 text-center border border-dashed border-[#1F1F33]">No CVEs match.</div>}
      </div>
    </div>
  );
}
